import React, { useState } from 'react';
import { LoginPage } from './pages/LoginPage';
import { GateEntryPage } from './pages/GateEntryPage';
import { VehicleEntryDetailPage } from './pages/VehicleEntryDetailPage';
import { VehicleFinalExitPage } from './pages/VehicleFinalExitPage';
import { CreateBillingPage } from './pages/CreateBillingPage';
import { BilledDetailsPage } from './pages/BilledDetailsPage';
import { BillingAndExitPage } from './pages/BillingAndExitPage';
import { VehicleDetentionReportPage } from './pages/VehicleDetentionReportPage';
import { UserReportPage } from './pages/UserReportPage';
import { POSVehicleDetentionPage } from './pages/POSVehicleDetentionPage';
import { MISReportPage } from './pages/MISReportPage';
import { POSUserReportPage } from './pages/POSUserReportPage';
import { CouponGenerationPage } from './pages/CouponGenerationPage';
import { CouponUsedReportPage } from './pages/CouponUsedReportPage';
import { POSCouponUsedReportPage } from './pages/POSCouponUsedReportPage';
import { HardwareStatusPage } from './pages/HardwareStatusPage';
import { DashboardLayout } from './components/DashboardLayout';
import { PageId } from './components/Sidebar';
export function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState('');
  const [activePage, setActivePage] = useState<PageId>('gate-entry');
  const handleLogin = (email: string) => {
    setUserName(email);
    setIsLoggedIn(true);
  };
  const handleLogout = () => {
    setIsLoggedIn(false);
    setUserName('');
    setActivePage('gate-entry');
  };
  if (!isLoggedIn) {
    return <LoginPage onLogin={handleLogin} data-id="element-0" />;
  }
  return <DashboardLayout activePage={activePage} onPageChange={setActivePage} userName={userName} onLogout={handleLogout} data-id="element-1">
      {activePage === 'gate-entry' && <GateEntryPage userName={userName} data-id="element-2" />}
      {activePage === 'vehicle-entry-detail' && <VehicleEntryDetailPage userName={userName} data-id="element-3" />}
      {activePage === 'vehicle-final-exit' && <VehicleFinalExitPage data-id="element-4" />}
      {activePage === 'create-billing' && <CreateBillingPage userName={userName} data-id="element-5" />}
      {activePage === 'billed-details' && <BilledDetailsPage data-id="element-6" />}
      {activePage === 'billing-and-exit' && <BillingAndExitPage userName={userName} data-id="element-7" />}
      {activePage === 'vehicle-detention-report' && <VehicleDetentionReportPage data-id="element-8" />}
      {activePage === 'user-report' && <UserReportPage data-id="element-9" />}
      {activePage === 'mis-report' && <MISReportPage data-id="element-10" />}
      {activePage === 'pos-vehicle-detention' && <POSVehicleDetentionPage data-id="element-11" />}
      {activePage === 'pos-user-report' && <POSUserReportPage data-id="element-12" />}
      {activePage === 'coupon-generation' && <CouponGenerationPage data-id="element-13" />}
      {activePage === 'coupon-used-report' && <CouponUsedReportPage data-id="element-14" />}
      {activePage === 'pos-coupon-used-report' && <POSCouponUsedReportPage data-id="element-15" />}
      {activePage === 'hardware-status' && <HardwareStatusPage data-id="element-16" />}
    </DashboardLayout>;
}